module.exports = __webpack_public_path__ + "media/images/trust-icon-detection-308283be164a96fd437b006618876590.svg";